import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { context, trace, type Span } from '@opentelemetry/api';
import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { CustomAttributesSpanProcessor } from './otel-custom-attributes-span-processor';

const traceTagName = 'traceparent';

export function updateMetaTag() {
  const currentContext = context.active();
  const span = trace.getSpan(currentContext);
  if (span) {
    const spanContext = span.spanContext();
    const metaTag = document.querySelector(`meta[name="${traceTagName}"]`);
    const version = '00';
    const flag = '01'; // "sampled"
    const newContent = `${version}-${spanContext?.traceId}-${spanContext?.spanId}-${flag}`;
    if (metaTag) {
      metaTag.setAttribute('content', newContent);
    } else {
      const newMetaTag = document.createElement('meta');
      newMetaTag.name = traceTagName;
      newMetaTag.content = newContent;
      document.head.appendChild(newMetaTag);
    }
  }
}

export function createAndStartOTelSpan(
  endpoint: string,
  openTelemetryRegexFeatureFlag: string,
  procoreObservabilityKeep: boolean
) {
  const excludeURLsRegex = new RegExp(openTelemetryRegexFeatureFlag);
  const configDefaults = {
    // This setting tells OpenTelemetry to not automatically create spans for network requests (XHR and Fetch)
    ignoreNetworkEvents: true,
    propagateTraceHeaderCorsUrls: excludeURLsRegex,
  };

  const debug =
    process.env.ENV === 'development' || process.env.ENV === 'staging';
  /* istanbul ignore next */
  const honeycombConfig = {
    debug,
    endpoint,
    spanProcessor: new CustomAttributesSpanProcessor(procoreObservabilityKeep),
    skipOptionsValidation: true,
    serviceName: 'construction-network-front-end',
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-xml-http-request': {
          clearTimingResources: true,
          applyCustomAttributesOnSpan(span, xhr) {
            if (excludeURLsRegex.test(xhr.responseURL)) {
              span.setAttribute('app.synthetic_request', 'false');
            }
          },
          ...configDefaults,
        },
        '@opentelemetry/instrumentation-fetch': {
          clearTimingResources: true,
          applyCustomAttributesOnSpan(span, request) {
            if (
              request instanceof Request &&
              excludeURLsRegex.test(request.url)
            ) {
              span.setAttribute('app.synthetic_request', 'false');
            }
          },
          ...configDefaults,
        },
        '@opentelemetry/instrumentation-document-load': configDefaults,
      }),
    ],
  };
  const sdk = new HoneycombWebSDK(honeycombConfig);
  sdk.start();

  const tracer = trace.getTracer('construction-network-front-end', '0.1.0');
  const span: Span = tracer.startSpan(
    'construction-network-front-end root span',
    {
      attributes: {
        'otel.exporter.otlp.endpoint': endpoint,
      },
    }
  );

  context.with(trace.setSpan(context.active(), span), () => {
    updateMetaTag();
    span.end();
  });
}
